import PageHero from "../components/PageHero";

export default function Privacy() {
  return (
    <div data-testid="page-privacy">
      <PageHero
        overline="Legal"
        title="Privacy Policy"
        subtitle="Last updated: January 2026"
      />
      <section className="py-16 md:py-24 bg-cream">
        <div className="max-w-3xl mx-auto px-6 md:px-12 lg:px-16 font-body text-ink-700 text-lg leading-relaxed space-y-6 [&_h2]:font-headings [&_h2]:text-3xl [&_h2]:text-ink [&_h2]:mt-12 [&_h2]:mb-3 [&_h2]:tracking-tight [&_h2]:leading-tight">
          <p>
            Unite Recruitment respects your privacy and is committed to handling
            your personal information in accordance with the Privacy Act 2020
            (New Zealand). This policy explains what we collect, why, and how we
            use it.
          </p>

          <h2>1. Information we collect</h2>
          <p>
            We may collect your name, contact details, employment history,
            qualifications, references, salary expectations, and any other
            information you provide when registering with us, submitting your
            CV, or engaging our services. We also collect basic analytics
            information when you use our website.
          </p>

          <h2>2. How we use it</h2>
          <p>
            We use your information to provide technology recruitment services, match you
            with relevant opportunities, communicate with you, and meet our
            legal obligations. We will only share your CV with a prospective
            employer once we have your permission to do so.
          </p>

          <h2>3. Sharing</h2>
          <p>
            We do not sell your information. We may share it with prospective
            employers (with your consent), trusted service providers (such as
            our CRM and email systems), and where required by law.
          </p>

          <h2>4. Storage and security</h2>
          <p>
            Your information is stored securely and access is restricted to
            staff who need it to provide our services. We retain candidate
            information for as long as it is useful for our technology recruitment
            services, and you can ask us to delete it at any time.
          </p>

          <h2>5. Cookies & analytics</h2>
          <p>
            We use cookies and analytics tools to understand how visitors use
            our website. You can disable cookies in your browser settings.
          </p>

          <h2>6. Your rights</h2>
          <p>
            Under the Privacy Act 2020 you have the right to access and correct
            personal information we hold about you. To make a request, email{" "}
            <a
              href="mailto:Bronwyn@uniterecruitment.co.nz"
              className="underline text-ink"
            >
              Bronwyn@uniterecruitment.co.nz
            </a>.
          </p>

          <h2>7. Changes</h2>
          <p>
            We may update this policy from time to time. The current version
            will always be posted on this page.
          </p>

          <h2>8. Contact</h2>
          <p>
            For privacy enquiries, email{" "}
            <a
              href="mailto:Bronwyn@uniterecruitment.co.nz"
              className="underline text-ink"
            >
              Bronwyn@uniterecruitment.co.nz
            </a>{" "}
            or call{" "}
            <a href="tel:+64274382028" className="underline text-ink">
              0274 382 028
            </a>.
          </p>
        </div>
      </section>
    </div>
  );
}
